import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import { link } from '@elab/core/utils/htmlTemplates';

export class OrderHistoryOrderNumber extends SimpleLitElement {
    static get properties() {
        return {
            code: { type: String },
            orderNrLabel: { type: String, attribute: 'order-nr-label' },
            orderDetailsUrl: { type: String, attribute: 'order-details-url' },
            viewDetailsLabel: { type: String, attribute: 'view-details-label' },
            statusDisplay: { type: String, attribute: 'status-display' },
            documents: { type: Object },
            collectionReceiptLabel: {
                type: String,
                attribute: 'collection-receipt-label',
            },
        };
    }

    constructor() {
        super();

        this.orderNrLabel = '';
        this.code = '';
        this.orderDetailsUrl = '';
        this.viewDetailsLabel = '';
        this.statusDisplay = '';
        this.documents = {};
        this.collectionReceiptLabel = '';
    }

    render() {
        return html`
            <div class="order-number-container">
                ${this.orderNrLabel && this.orderNrLabel}
                ${this.viewDetailsLabel
                    ? html`
                          <div>${this.code}</div>
                      `
                    : ''}
                ${link(
                    {
                        href: `${this.orderDetailsUrl}${this.code}`,
                        className: 'simple-link',
                    },
                    this.viewDetailsLabel ? this.viewDetailsLabel : this.code,
                )}
                ${this.statusDisplay === 'receivedAtStore' && this.documents
                    ? this.documents
                          .filter(doc => doc.label === 'pickupReceipt')
                          .map(link =>
                              link(
                                  {
                                      className: 'simple-link',
                                      href: link.downloadLink,
                                  },
                                  this.collectionReceiptLabel,
                              ),
                          )
                    : ''}
            </div>
        `;
    }
}

export default () =>
    customElements.define('e2-order-history-order-number', OrderHistoryOrderNumber);
